// src/index.jsx (o App.jsx)
import './style.css';
import React, { useState, useCallback } from 'react';
import ReactDOM from 'react-dom/client';
import { Canvas } from '@react-three/fiber';
import { motion, AnimatePresence } from 'framer-motion';

import Experience from './Experience.jsx';
import ScoreDisplay from './components/ScoreDisplay.jsx';
import StartScreen from './components/StartScreen.jsx';
import EndScreen from './components/EndScreen.jsx';

const root = ReactDOM.createRoot(document.querySelector('#root'));

const GAME_STATES = {
  START: 'START',
  PLAYING: 'PLAYING',
  GAME_OVER: 'GAME_OVER',
};

function App() {
  const [score, setScore] = useState(0);
  const [gameState, setGameState] = useState(GAME_STATES.START);
  const [finalScore, setFinalScore] = useState(0);

  const gameContainerStyle = {
    position: 'relative', // Contenidor principal per a elements absoluts
    width: '100%',
    height: '100%',
    overflow: 'hidden', // Evitar qualsevol desbordament inesperat
  };

  const handleStartGame = useCallback(() => {
    setScore(0);
    setGameState(GAME_STATES.PLAYING);
  }, []);

  const handleGameOver = useCallback(() => {
    setFinalScore(score);
    setGameState(GAME_STATES.GAME_OVER);
  }, [score]);

  const handlePlayAgain = useCallback(() => {
    setScore(0);
    // Podries tornar a START o directament a PLAYING si vols saltar la pantalla d'inici
    setGameState(GAME_STATES.START); 
  }, []);

  return (
    <div style={gameContainerStyle}>
      {/* ScoreDisplay es renderitza condicionalment però fora dels motion.div de les pantalles principals */}
      {/* Això assegura que no interfereix amb el layout del Canvas */}
      {gameState === GAME_STATES.PLAYING && <ScoreDisplay score={score} />}

      <AnimatePresence mode="wait">
        {gameState === GAME_STATES.START && (
          <motion.div
            key="startScreen"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, transition: { duration: 0.3 } }}
            style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0 }}
          >
            <StartScreen onStart={handleStartGame} />
          </motion.div>
        )}

        {gameState === GAME_STATES.PLAYING && (
          <motion.div
            key="playingScreen"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 0.3, delay: 0.3 } }}
            exit={{ opacity: 0, transition: { duration: 0.3 } }}
            // Assegura que aquest div ocupa tot l'espai i es posiciona correctament
            style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0 }}
          >
            {/* ScoreDisplay ja NO és aquí */}
            <Canvas
              // R3F per defecte agafa el 100% del seu pare si no s'especifica res
              camera={{
                fov: 35,
                near: 0.1,
                far: 200,
              }}
            >
              <Experience setAppScore={setScore} onGameOver={handleGameOver} />
            </Canvas>
          </motion.div>
        )}

        {gameState === GAME_STATES.GAME_OVER && (
          <motion.div
            key="endScreen"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 0.3, delay: 0.3 } }}
            exit={{ opacity: 0, transition: { duration: 0.3 } }}
            style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0 }}
          >
            <EndScreen score={finalScore} onPlayAgain={handlePlayAgain} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

root.render(<App />);